<template>
  <div class="whatsapp-blocker-overlay">
    <div class="whatsapp-blocker-card">
      <p class="whatsapp-blocker-message">
        🔒 <strong>Para acessar essa página, faça a autenticação com o WhatsApp.</strong>
      </p>
      <div class="whatsapp-blocker-buttons">
        <button @click="irParaQRCode" class="btn-primary">
          Autenticar com WhatsApp
        </button>
        <button @click="voltarPagina" class="btn-secondary">
          Voltar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();

function irParaQRCode() {
  router.push("/qr-code");
}

function voltarPagina() {
  const destino = "/pesquisa-cnpj";        //rota “segura”, sem bloqueio
  localStorage.setItem("currentPage", destino); // atualiza lastPage usado no beforeEach
  router.push(destino);
}
</script>

<style src="@/assets/styleWhatsappBlocker.css"></style>
